package devxertech.com.pages.blogs.blogPages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun BlogAboutSection(
    text: String = "Artificial Intelligence (AI) is no longer a futuristic concept it's here, it's now, and it's driving the most significant shift in business" +
        " transformation across the globe. As we navigate through 2025, companies that adopt AI are moving faster, serving smarter, and" +
        " competing stronger."
) {
    val breakpoint = rememberBreakpoint()
    val palette = ColorMode.current.toSitePalette()

    // Responsive margin based on screen size
    val width = when {
        breakpoint > Breakpoint.LG -> 62.percent
        else -> 90.percent
    }

    Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
        Row(
            modifier = Modifier
                .fillMaxWidth(width)
                .padding(leftRight = 20.px, topBottom = 20.px)
                .margin(topBottom = 40.px)
                .borderRadius(8.px)
                .flexWrap(FlexWrap.Wrap)
                .backgroundColor(palette.blogPage.rgb)
                .alignContent(AlignContent.Center),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            FieldTitleTextNormalSimple(
                text = text,
                fontSize = if (window.screen.width > 1600) 18.px else 14.px
            )
        }
    }
}
